<script>
	import request from "$misc/request";
	import Captcha from "$lib/Captcha.svelte";
	import ContactForm from "./signup/ContactForm.svelte";
	import CompanyForm from "./signup/CompanyForm.svelte";
	import ProgressBubbles from "$lib/ProgressBubbles.svelte";
	import { isTouchDevice } from "$misc/utils";
	import Modal from "$lib/Modal.svelte";

	const data = { contact: {}, company: {} };
	const state = {
		stage: 1,
		form: "contact",
		button: {
			text: "Next",
			type: "button",
		},
		tagline: "primary contact person",
	};

	let action;
	let disabled = true;
	let country_code = "";
	let validateInteraction;
	let continueWithApp = false;

	const validate = ({ detail }) => {
		const { form, validated, code } = detail;
		country_code = code ?? country_code;

		if (form == "contact" && validated) {
			action = () => {
				progress();
				data.contact = add_country_code(data.contact);
				window.history.pushState({ step: 2 }, "");
			};
		}

		if (form == "company" && validated) {
			action = register;
		}

		disabled = !validated;
	};

	const progress = () => {
		state.stage = 2;
		state.form = "company";
		state.tagline = "individual / company / business";
		state.button.type = "submit";
		state.button.text = "Get Started";
		disabled = true;

		form_validate && form_validate();
	};

	const regress = () => {
		action = progress;
		disabled = false;

		state.stage = 1;
		state.form = "contact";
		state.tagline = "primary contact person";
		state.button.type = "button";
		state.button.text = "Next";

		if (history.state) {
			history.back();
			form_validate && form_validate();
		}
	};

	window.onpopstate = function (event) {
		if (event.state === null) {
			regress();
		} else {
			progress();
		}
	};
	const add_country_code = (data) => {
		data.cellphone_number = country_code + data.cellphone_number;
		return data;
	};

	const register = async () => {
		const text = state.button.text;
		const parameters = { ...data.company, ...data.contact };

		state.button.text =
			"<img height='20' src='/img/Busyindicator-white.gif' alt='Loading...' >";
		disabled = true;

		alertMessage("Creating account...", { level: "info" });

		if (await validateInteraction()) {
			parameters.login = !isTouchDevice();

			(await request("api/register.php", parameters)).match({
				left: (error) => {
					const options = { level: "warning" };
					disabled = !(state.button.text = text);

					if (error.status >= 500) {
						options.timeout = false;
						alertMessage(
							"Error creating your account! Please try again later.",
							options
						);
					} else {
						alertMessage(error.message ?? error, options);
					}
				},
				right: (message) => {
					if (isTouchDevice()) {
						window.location = "/accounts/account_labels2.php";
						return (state.stage = 3);
					}
					continueWithWebApp(message, parameters);
				},
			});
		} else {
			alertMessage(
				"Error validating reCaptcha. Please reload this page and try again",
				{ level: "warning" }
			);
		}
	};

	let web = () => (continueWithApp = false);

	const continueWithWebApp = async (response, parameters) => {
		const categories = "/accounts/account_labels.php?status=new";
		continueWithApp = false;

		if (response.account && !parameters.login) {
			(await request("api/autologin.php", { account, email, password })).match({
				left: (error) => {
					alertMessage(error.message, { level: "warning" });
				},
				right: (response) => {
					alertMessage(`${response.message}. Redirecting you now...`, options);
				},
			});
		} else if (
			response === "Account created successfully" ||
			response.includes("Email not sent")
		) {
			const options = { level: "success" };
			alertMessage(`${response}. Redirecting you now...`, options);
			setTimeout(() => (window.location = categories), 2000);
			state.stage = 3;
		} else {
			alertMessage("Unknown error occurred!", { level: "danger" });
		}
	};

	let form_validate;

	const enter = () => {
		const handlePress = (ev) => {
			const next = document.querySelector(".card-footer .btn.btn-blue");
			const active = document.activeElement;

			if (ev.code === "Enter" && disabled) {
				return form_validate && form_validate();
			}

			if (state.stage === 2 && ev.code === "Enter" && !disabled) {
				const back = document.querySelector(".card-footer .btn.mr-2");

				if (active !== back && active !== next) {
					next.click();
				}
			} else if (next.textContent.trim() === "Next" && ev.code === "Enter") {
				if (active !== next) {
					next.click();
				}
			}
		};

		window.addEventListener("keypress", handlePress);

		return {
			destroy() {
				window.removeEventListener("keypress", handlePress);
			},
		};
	};
</script>

<div class="container-fluid qualimi qualimi--background-blue">
	<Captcha bind:validateInteraction />

	<nav class="navigation navigation--padded">
		<a href="/" class="brand">Home</a>

		<div class="navigation__links">
			Already have an account?
			<a href="/login.php" style="margin-left: 0.5em; color: white">Log in</a>
		</div>
	</nav>

	<main class="d-flex justify-content-center">
		<div class="card">
			<div class="card-head p-2">
				<ProgressBubbles
					postfix="progress-indicators--signup"
					bind:stage={state.stage}
				/>
				<h3 class="card-title m-0">Sign up for free</h3>
				<p
					class="card-tagline card-tagline--font-large text-muted text-center m-0"
				>
					Details of {state.tagline}
				</p>
			</div>

			<div class="card-body p-3 px-4" use:enter>
				{#if state.form === "contact"}
					<ContactForm
						on:validated={validate}
						bind:validate={form_validate}
						bind:values={data.contact}
					/>
				{:else}
					<CompanyForm
						on:validated={validate}
						bind:validate={form_validate}
						bind:values={data.company}
					/>
				{/if}
			</div>

			<div class="card-footer p-2 px-4">
				{#if state.form === "company"}
					<button class="btn mr-2" type="button" on:click={regress}>
						Back
					</button>
				{/if}

				<button
					class="btn btn-blue"
					type={state.button.type}
					on:click={action}
					{disabled}
				>
					{@html state.button.text}
				</button>

				{#if state.form === "contact"}
					<p class="card-tagline text-muted my-1">
						*1-month free trial, no credit card required.
					</p>
				{/if}
			</div>
		</div>
	</main>

	{#if continueWithApp}
		<Modal>
			<div
				class="modal fade show"
				id="intercept_signup_modal"
				data-backdrop="static"
				data-keyboard="false"
				tabindex="-1"
				role="dialog"
				aria-labelledby="staticBackdropLabel"
				aria-hidden="false"
				style="display: block"
				aria-modal="true"
			>
				<div class="modal-dialog modal-xl p-4" style="max-width:900px">
					<div class="modal-content">
						<div
							class="modal__title card-header blue-heading"
							style="padding-left: 20px; font-size: 22px;"
						>
							Download the app
						</div>
						<div
							id="intercept_signup_modal_logo"
							class="mx-auto"
							style="text-align: center;padding-top: 15px;"
						>
							<a href="/">
								<img
									src="../img/Qualimi_Logo_Colour-07.svg"
									width="75%"
									alt=""
								/>
							</a>
						</div>
						<div
							class="modal-body text-center qmodal-header blue-heading"
							style="font-size: 22px;"
						>
							Download the Qualimi app<br />
							<span id="sub_mess_download">and log in</span>
							<br /> <br />
							<div>
								<div>
									<input
										class="d-none"
										id="Vrgqnf"
										type="checkbox"
										checked=""
									/>
									<a
										id="pzc6ed"
										href="/accounts/account_labels2.php"
										style="font-size: 3rem; color: white"
									>
										<img
											style="display: inline-block;margin-left: auto;margin-right: auto;max-width: 90%;"
											border="0"
											alt="Apple App Store"
											title="Apple App Store"
											src="../img/appstore114.png"
										/>
									</a>
								</div>
							</div>
							<br />
							<div id="show_web" style="font-size: 18px;">
								or continue with
								<br />
								<button
									type="button"
									class="btn btn-link continue"
									on:click={web}
								>
									Qualimi web application
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	{/if}
</div>

<!-- 2. borders of the fields our light blue #5584B2 and a little thicker -->
<style lang="scss" global>
	:global {
		@import "../scss/component.signup.scss";
	}

	.form-control {
		border: 1px solid #5584b2bb;
	}

	.continue-with-app {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;

		.link-container {
			background: white;
			width: fit-content;
			padding: 3em;
			border-radius: var(--qualimi-card-radius);
		}
	}

	.btn.continue {
		font-size: 1em;
		padding: 0.5em 2em;
		margin-bottom: 0.75em;
	}

	.card {
		width: 30vw;

		.card-body {
			padding-top: 1.25rem;
			padding-bottom: 1rem;
		}

		@media only screen and (max-width: 991px) {
			width: 50vw !important;
		}

		@media only screen and (max-width: 768px) {
			width: 65vw !important;

			& .card-title {
				font-size: 4em;
				margin: 0.35 !important;
			}

			& .card-tagline {
				font-size: 2.5em;
				margin-bottom: 1em;
				&--font-large {
					font-size: 2.85em;
				}
			}

			& .card-footer {
				margin-top: 2em;
			}

			.progress-indicators {
				&--signup {
					width: 25% !important;
				}
				&::before {
					height: 3px;
					width: calc(100% - 2.5em);
				}
			}

			.bubble {
				padding: 1.5em;

				&--active {
					box-shadow: 0px 0px 0px 2em var(--qualimi-yellow-alpha);
				}
			}

			.form-group + .form-group {
				margin-top: 2.75em;
			}

			label {
				font-size: 2.75em;
			}

			.input-group .form-control {
				border-top-left-radius: 0.8rem !important;
				border-top-right-radius: 0 !important;
				border-bottom-left-radius: 0.8rem !important;
				border-bottom-right-radius: 0 !important;
			}

			.form-control {
				font-size: 2.75em;
				padding: 0.35em !important;
				border-radius: 0.8rem;

				&::placeholder {
					color: var(--qualimi-yellow-alpha);
					font-size: 2.35rem !important;
				}
			}

			.custom-control-label {
				font-size: 2.65em !important;
				padding-left: 1.5em;

				&::before,
				&::after {
					top: 50%;
					width: 1.5em;
					height: 1.5em;
					transform: translateY(-50%);
				}
			}

			.field__password-requirements {
				margin: 1em 0.25em 3em;
				span {
					font-size: 2.35em !important;
				}
			}

			.field__feedback {
				font-size: 2.45em;
			}

			.btn {
				font-size: 2.5em !important;
				padding: 0.5em 2em;
				margin-bottom: 0.75em;
			}
		}

		@media only screen and (max-width: 575px) {
			width: 80vw !important;
		}
	}

	#div_alert.alert {
		max-width: calc(100vw - 25px) !important;

		.input-group-text {
			font-size: 2em;
		}

		.form-control {
			@media all and (max-width: 575px) {
				font-size: 2.1rem !important;
			}
		}
	}
</style>
